import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledCarouselList, StyledCarouselButton } from './Carousel.styles';
import SVGIcon from '../SVGIcon';
import { colors } from '../css';

/* eslint-disable react/jsx-no-bind */
/**
 * PagingDots overwrites the default components used in the pagination of the bottom controls of the Carousel.
 * If we need to change the icon or other functionality of the Carousel dots this is where we would do it.
 */
class PagingDots extends Component {
  static propTypes = {
    slideCount: PropTypes.number.isRequired,
    slidesToScroll: PropTypes.number.isRequired,
    goToSlide: PropTypes.func.isRequired,
    currentSlide: PropTypes.number.isRequired,
    dotColor: PropTypes.string
  };

  static defaultProps = {
    dotColor: colors.colorBurgundy
  };

  getIndexes() {
    const { slideCount, slidesToScroll } = this.props;
    const arr = [];
    for (let i = 0; i < slideCount; i += slidesToScroll) {
      arr.push(i);
    }
    return arr;
  }

  render() {
    const { goToSlide, currentSlide, dotColor } = this.props;
    const indexes = this.getIndexes();

    // Round current slide up if it is a decimal - used when next/prev slide is 'peaking'
    let roundCurrentSlide = currentSlide;
    if (currentSlide % 1 !== 0) {
      roundCurrentSlide = Math.ceil(currentSlide);
    }

    return (
      <StyledCarouselList>
        {indexes.map(index => (
          <li
            style={{
              listStyleType: 'none',
              display: 'inline-block'
            }}
            key={index}
          >
            <StyledCarouselButton active={roundCurrentSlide === index} onClick={goToSlide.bind(null, index)}>
              <SVGIcon selectedIcon="carousel" iconColor={roundCurrentSlide === index ? dotColor : undefined} />
            </StyledCarouselButton>
          </li>
        ))}
      </StyledCarouselList>
    );
  }
}

export default PagingDots;
